// CSS
import '../sass/pages/contact.scss'

// === WP ALPHA ASSETS
import '@nematis/wp-alpha/assets/js/contact'

// adjust contact map zoom level
document.addEventListener('alpha.loaded', (e) => {
  const moduleMgr = e.detail.emitter
  moduleMgr.addModuleEventListener('leafletMap', 'map.loaded', (evt) => {
    const mapInfo = evt.mapInfo
    const map = mapInfo.map
    const viewportModule = moduleMgr.getModule('viewport')
    if (viewportModule && viewportModule.getViewport().is('>=lg')) {
      map.setZoom(11)
    }
  })
})
